let enabled = false;

export const startWritingToMemento = () => {
  enabled = true;
};
export const isMementoEnabled = () => enabled;
